import axios from "../config/axios";

class SubscriptionService {
  // Récupérer tous les plans et l'abonnement actuel
  async getPlans() {
    try {
      const response = await axios.get("/subscriptions");
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des plans:", error);
      throw error;
    }
  }

  // Souscrire à un plan
  async subscribe(planId) {
    try {
      const response = await axios.get(`/subscriptions/${planId}`);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la souscription:", error);
      throw error;
    }
  }

  // Récupérer l'historique des abonnements
  async getHistory(page = 1) {
    try {
      const response = await axios.get(`/subscriptions-histories?page=${page}`);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération de l'historique:", error);
      throw error;
    }
  }

  // Obtenir le portail de facturation
  async getBillingPortal() {
    try {
      const response = await axios.get("/subscriptions-manage");
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération du portail:", error);
      throw error;
    }
  }

  // Annuler l'abonnement (fin de période)
  async cancelSubscription() {
    try {
      const response = await axios.get("/subscriptions-cancel");
      return response.data;
    } catch (error) {
      console.error("Erreur lors de l'annulation:", error);
      throw error;
    }
  }

  // Annuler immédiatement l'abonnement
  async cancelNowSubscription() {
    try {
      const response = await axios.get("/subscriptions-cancel-now");
      return response.data;
    } catch (error) {
      console.error("Erreur lors de l'annulation immédiate:", error);
      throw error;
    }
  }
  async pauseSubscription() {
    try {
      const response = await axios.get("/subscriptions-cancel");
      return response.data;
    } catch (error) {
      console.error("Erreur lors de l'annulation immédiate:", error);
      throw error;
    }
  }

  // Changer de plan
  async swapPlan(planId) {
    try {
      const response = await axios.get(`/subscriptions-swap/${planId}`);
      return response.data;
    } catch (error) {
      console.error("Erreur lors du changement de plan:", error);
      throw error;
    }
  }

  // Page de succès
  async getSuccessPage() {
    try {
      const response = await axios.get("/subscriptions-success");
      return response.data;
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  }
  async checkSubscription() {
    try {
      const response = await axios.get("/subscriptions-check");
      return response.data;
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  }
  async resumeSubscription() {
    try {
      const response = await axios.get("/subscriptions-resume");
      return response.data;
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  }
}

export default new SubscriptionService();
